// extracted by mini-css-extract-plugin
module.exports = {"partnerMaskWrapper":"fztd1"};